import { Injectable } from '@angular/core';
import {HttpClient, HttpRequest, HttpEvent, HttpParams, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import {UploadFile} from "./upload-file";
import {TokenStorageService} from "../_services/token-storage.service";
const httpOptions = {
  headers: new HttpHeaders({'Content-Type' : 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {


  constructor(private http: HttpClient, private token: TokenStorageService) { }

  /*upload(url: string, file: File, imgCount: string, imgName: string, username: string): Observable<HttpEvent<unknown>> {
    console.log(this.token.getToken());
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('filename', imgName);
    formData.append('directory', imgCount );
    formData.append('username', username );

    const req = new HttpRequest('POST', url + '/upload', formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }*/

  getItem(url: string, id : string) {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get(url + '/item', {params:params});
  }

  upload(file: File,  url: string, itemId: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('itemId', itemId);

    const req = new HttpRequest('POST', `${url}/upload`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  saveItem(url: string,  item: any) {
    let params = new HttpParams();
    params = params.append('itemName', item);
    return this.http.get(url + '/item' /* motors reg removed */, {params:params});
  }

  updateItem(url: string,  itemId: any): Observable<any> {
    return this.http.get(url + '/update-item', itemId);
  }

  // upload(url: string, file: UploadFile): Observable<any> {
  //   return this.http.post(url + '/upload', {
  //     file: file.file,
  //     fileName: file.fileName,
  //     directory: file.directory
  //   }, httpOptions);
  // }

  getFiles(url : string, itemId): Observable<any> {
    let params = new HttpParams();
    params = params.append('itemId', itemId);
    return this.http.get(url + '/files', {params:params});
  }

  getCounties(url: string) {
    return this.http.get(url);
  }

  getCategories(url: string) {
    return this.http.get(url);
  }

  getSubCategories(url: string, category: string) {
    let params = new HttpParams();
    params = params.append('category', category);
    return this.http.get(url, {params:params});
  }

  getSubSubCategories(url: string, subcategory: string) {
    let params = new HttpParams();
    params = params.append('subcategory', subcategory);
    return this.http.get(url, {params:params});
  }

  /** Category-agnostic listing publish (taxonomy from payload URL). */
  publishItemListing(url: string, formData: FormData): Observable<any> {
    return this.http.post(`${url}/item-listings`, formData);
  }

  updateItemListing(url: string, itemId: string, itemData: unknown): Observable<any> {
    return this.http.put(`${url}/item-listings/${itemId}`, itemData, httpOptions);
  }

  getListingForEdit(url: string, itemId: string): Observable<any> {
    const params = new HttpParams().set('id', itemId);
    return this.http.get(`${url}/item`, {params});
  }

  saveCategory(url: string, categoriesArray: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    // Sent in the request body (not as a query param) because the payload can be
    // large now that it carries full SVG file contents.
    return this.http.post(url, categoriesArray, {headers: headers});
  }
}
